import {ExchangeNodeName} from "#material/exchange/node-name"
import {z} from "zod/v4-mini"

export const exchangeNodeNameSchema = z.enum(ExchangeNodeName)
